export default __webpack_public_path__ + "static/media/gallery_02.a9b650dd.jpg";